import React from 'react';
import { Container, sectionWrapperProps } from './SectionWrapper.styles';

const SectionWrapper = ({
  children,
  height = '',
  padding = '44px 44px',
  bgColor = '#fff'
}: sectionWrapperProps) => {
  return (
    <Container
      padding={padding}
      height={height}
      bgColor={bgColor}
    >
      {children}
    </Container>
  );
};

export default SectionWrapper;
